export const LORE_SECTIONS = [
  {
    id: 'protocols',
    nameZh: '协议档案',
    nameEn: 'PROTOCOL RECORDS',
    code: 'PR',
    blurb: '被批准给受试者看的规则，以及不该被看到的那部分。',
  },
  {
    id: 'duty',
    nameZh: '值班室',
    nameEn: 'DUTY OFFICE',
    code: 'DO',
    blurb: '交接、维修、清洁与安保留下的日常记录。',
  },
  {
    id: 'intake',
    nameZh: '登记处',
    nameEn: 'INTAKE',
    code: 'IN',
    blurb: '配对、既往史、家属通知与稳定度评估。',
  },
  {
    id: 'chorus',
    nameZh: '广播室',
    nameEn: 'CHORUS',
    code: 'CH',
    blurb: 'CHORUS 播报稿、误播与操作员交接。',
  },
  {
    id: 'civilian',
    nameZh: '民间档案',
    nameEn: 'CIVILIAN LEAKAGE',
    code: 'CV',
    blurb: '这套方法进入学校、工厂、媒体与日常生活后留下的印刷品。',
  },
  {
    id: 'anomaly',
    nameZh: '失联样本',
    nameEn: 'MISSING SAMPLE',
    code: 'MS',
    blurb: '一个离开 Site 06 的受试者留下的残页。',
  },
  {
    id: 'committee',
    nameZh: '委员会',
    nameEn: 'DIRECTORATE',
    code: 'DR',
    blurb: '从未公开的复验委员会会议纪要。',
  },
] as const;

export type LoreSection = (typeof LORE_SECTIONS)[number]['id'];

export type LoreTemplate =
  | 'protocol'
  | 'memo'
  | 'intake'
  | 'transcript'
  | 'ephemera'
  | 'fragment'
  | 'minutes';

export type LoreReliability =
  | 'verified'
  | 'partial'
  | 'contradicted'
  | 'redacted'
  | 'unverified';

export type LoreBlock =
  | { type: 'p'; text: string }
  | { type: 'h'; text: string }
  | { type: 'redacted'; text?: string; label?: string }
  | { type: 'quote'; text: string; source?: string }
  | { type: 'list'; items: string[]; ordered?: boolean }
  | { type: 'table'; head: string[]; rows: string[][] }
  | { type: 'stamp'; text: string; tone?: 'ink' | 'red' | 'muted' }
  | { type: 'note'; text: string }
  | { type: 'image'; src: string; alt: string; caption?: string }
  | { type: 'audio'; src: string; label: string; lang?: 'zh' | 'en' | 'bilingual' }
  | { type: 'divider' };

export interface LoreFragment {
  id: string;
  label: string;
  blocks: LoreBlock[];
}

export interface LoreDoc {
  id: string;
  section: LoreSection;
  template: LoreTemplate;
  code: string;
  title: string;
  subtitle?: string;
  date: string;
  reliability: LoreReliability;
  minProtocol: 1 | 2 | 3 | 4 | 5 | 6;
  tier: 1 | 2 | 3 | 4;
  fragments: LoreFragment[];
  tags: string[];
}

export interface LoreRewardView {
  fragmentId: string;
  docId: string;
  code: string;
  title: string;
  section: LoreSection;
  completedDoc: boolean;
}
